export default __webpack_public_path__ + "static/media/TV_Goiania.fw.c8307475.png";